import { HttpPromise } from "@shared/svelte/Modules/ApiService";

import { groupBy } from "lodash";

import type { Suggestion, SuggestionGroup } from "@shared/types/Suggestion";

export const parseSuggestion = (data: Suggestion, searchText: string): Suggestion => {
  let originalSuggestion = data.suggestion || "";
  let s = originalSuggestion;
  s = s.toLowerCase();
  let start = s.indexOf(searchText.toLowerCase());

  if (start < 0) {
    return {
      ...data,
      query: searchText,
      prefix: null,
      highlight: null,
      suffix: null,
      name: originalSuggestion,
      isMatched: false,
    };
  }
  let end = start + searchText.length;
  return {
    ...data,
    query: searchText,
    prefix: originalSuggestion.slice(0, start),
    highlight: originalSuggestion.slice(start, end),
    suffix: originalSuggestion.slice(end, originalSuggestion.length),
    name: originalSuggestion,
    isMatched: true,
  };
};

const filterSuggestions = (data: Suggestion[], searchText: string) => {
  return data
    .filter(s => !(s.suggestion == null) || s.suggestion == undefined || s.suggestion == "")
    .map(s => parseSuggestion(s, searchText));
};

const groupSuggestionsByField = (data: Suggestion[]): SuggestionGroup[] => {
  const groupedSuggestions = groupBy(data, "field");
  return Object.keys(groupedSuggestions).map(k => {
    return {
      header: k.replace("_", " ").toLowerCase(),
      suggestions: groupedSuggestions[k],
    };
  });
};

export const getSuggestions = async (
  searchText: string,
): Promise<{
  searchText: string;
  suggestions: Suggestion[];
  groupedSuggestions: SuggestionGroup[];
}> => {
  let groupedSuggestions: SuggestionGroup[];
  let suggestions: Suggestion[];
  try {
    const response = await HttpPromise({
      method: "GET",
      url: "/api/retailer/suggestions",
      data: {
        search: searchText,
      },
    });

    suggestions = filterSuggestions(response, searchText);
    groupedSuggestions = groupSuggestionsByField(suggestions);
  } catch (error) {
    groupedSuggestions = [];
    suggestions = [];
  }

  return { searchText, suggestions, groupedSuggestions };
};
